module.exports = __webpack_public_path__ + "static/media/logoMinotaBlanco.43ca8912.png";